import React, { Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {
  CONSENT_URL,
  DASHBOARD_URL,
  DOCUMENTS_URL,
  HOME_URL,
  LOGIN_URL,
  AUTH_LOGIN_URL,
  LOGOUT_URL2,
  // MESSAGING_URL,
  CASES_URL,
  ADMIN_URL,
  SERVICEINIT_URL,
  HELP_URL,
  QUESTIONNAIRE_URL,
  USERS_URL,
  ENGAGEMENTS_URL,
  IDVALIDATOR_URL,
  MANUALREQUESTQUEUE_URL,
  PAYWALLREQUESTQUEUE_URL,
  SITE_MAINTENANCE_URL,
  APP_UPDATE_URL,
  CASE_UPLOAD_URL,
  PREREGISTER_APPLICANTS_URL,
  PROFORMA_UPLOAD,
  TEST_PARSER,
  POWERBI_URL,
  LOBBY_MESSAGE_URL
} from 'src/constants/constants.js';

/* main features */
import Consent from 'src/ui/features/Consent';
import Documents from 'src/ui/features/Documents';
// import Messaging from 'src/ui/features/Messaging';
import AppUpdate from 'src/ui/features/AppUpdate';
import Admin from 'src/ui/features/Admin';
import ServiceInit from 'src/ui/features/ServiceInit';
import Help from 'src/ui/features/Help';
import Questionnaire from 'src/ui/features/Questionnaire';
//import { routeChange } from './metrics/metricAction';
import { history, store } from './store/configureStore';
import TestParser from './ui/features/TestParser'; // this will be removed when questionnaire testing
import requireAuth from 'src/utils/requireAuth';
import { SiteMaintenanceContainer } from 'src/ui/features/Maintenance';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

//Lazy Load
const Login = lazy(() => import('src/ui/features/Login'));
const Dashboard = lazy(() => import('src/ui/features/Dashboard'));
const Home = lazy(() => import('src/ui/features/Home'));
const Cases = lazy(() => import('src/ui/features/Cases'));
const PowerBiLaunch = lazy(() => import('src/ui/features/PowerBiLaunch'));
const Users = lazy(() => import('src/ui/features/Users'));
const Engagements = lazy(() => import('src/ui/features/Engagements'));
const PreregisterApplicants = lazy(() => import('src/ui/features/PreregisterApplicants'));
const CaseUpload = lazy(() => import('src/ui/features/CaseUpload'));
const ProformaUpload = lazy(() => import('src/ui/features/ProformaUpload'));
const IdValidator = lazy(() => import('src/ui/features/IdValidator'));
const LobbyMessage = lazy(()=> import('src/ui/features/LobbyMessage'));
const Paywall = lazy(() => import('src/ui/features/Paywall'));

// let prevLocation = {};
// history.listen(location => {
//   if (location.pathname !== prevLocation.pathname) {
//     store.dispatch(routeChange(location));
//     prevLocation = location;
//   }
// });

let routes = (
  <Suspense fallback={<ServiceSpinner open={true} />}>
    <Switch key="router" history={history}>
      <Route path={SITE_MAINTENANCE_URL} component={props => <SiteMaintenanceContainer {...props} />} />
      <Route path={CONSENT_URL} component={requireAuth(Consent)} />
      <Route path={QUESTIONNAIRE_URL} component={requireAuth(Questionnaire)} />
      <Route path={DASHBOARD_URL} component={requireAuth(Dashboard)} />
      <Route path={DOCUMENTS_URL} component={requireAuth(Documents)} />
      <Route path={HOME_URL} component={requireAuth(Home)} />
      {/* <Route path={MESSAGING_URL} component={requireAuth(Messaging)} /> */}
      <Route path={CASES_URL} component={requireAuth(Cases)} />
      <Route path={APP_UPDATE_URL} component={requireAuth(AppUpdate)} />
      <Route path={CASE_UPLOAD_URL} component={requireAuth(CaseUpload)} />
      <Route path={PREREGISTER_APPLICANTS_URL} component={requireAuth(PreregisterApplicants)} />
      <Route path={PROFORMA_UPLOAD} component={requireAuth(ProformaUpload)} />
      <Route path={ADMIN_URL} component={requireAuth(Admin)} />
      <Route path={LOBBY_MESSAGE_URL} component={requireAuth(LobbyMessage)} />
      <Route path={HELP_URL} component={requireAuth(Help)} />
      <Route path={POWERBI_URL} component={requireAuth(PowerBiLaunch)} />
      <Route path={SERVICEINIT_URL} component={requireAuth(ServiceInit)} />
      <Route path={USERS_URL} component={requireAuth(Users)} />
      <Route path={ENGAGEMENTS_URL} component={requireAuth(Engagements)} />
      <Route path={IDVALIDATOR_URL} component={requireAuth(IdValidator)} />
      <Route path={MANUALREQUESTQUEUE_URL} component={requireAuth(IdValidator)} />
      <Route path={PAYWALLREQUESTQUEUE_URL} component={requireAuth(Paywall)} />
      <Route path={TEST_PARSER} exact component={props => <TestParser {...props} />} />
      <Route path={LOGIN_URL} component={requireAuth(Login, false)} />
      <Route path={AUTH_LOGIN_URL} component={requireAuth(Login, false)} />
      <Route path="*" component={props => <Redirect {...props} to={LOGIN_URL} />} />
    </Switch>
  </Suspense>
);

if (sessionStorage.getItem('CN')) {
  routes = (
    <Switch key="router" history={history}>
      <Route path={CONSENT_URL} component={Consent} />
      <Route path={LOGOUT_URL2} component={Login} />
      <Route path="*" component={props => <Redirect to={LOGOUT_URL2} />} />
    </Switch>
  );
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js